import React from 'react';

const Select = ({children, ...props}) => {
    return (
        <div className="select bp3-select">
            <select {...props}>
                {children}
            </select>
        </div>
    );
};

export default Select;